import { imageUrlToBase64 } from "@/views/bulletinv2/studentMarks/scripts/bulletinHeplers/custom/common";

/** Same logo resolution as bulletin/PV helpers: signed URL from settings.image, or resourcesUrl. */
export function resolveSchoolLogoUrl(settings, activeBuilding) {
  const logoEntry = (settings?.image || []).find(
    (img) => img.db === activeBuilding || img.dbName === activeBuilding
  );
  const logo = logoEntry?.logo;
  if (!logo) return null;
  if (/^https?:\/\//i.test(logo) || logo.startsWith("data:")) return logo;
  if (settings?.resourcesUrl) {
    return settings.resourcesUrl.replace("FILE_PATH", logo);
  }
  if (settings?.base_url) {
    return `${settings.base_url}/${String(logo).replace(/^\//, "")}`;
  }
  return logo;
}

export function formatSchoolarYearName(settings) {
  const entry = settings?.schoolarYears?.find(
    (el) => el._id == settings.activeSchoolarYear
  );
  if (!entry) return "";
  const start = new Date(entry.start).getFullYear();
  const end = new Date(entry.end).getFullYear();
  return `${end} / ${start}`;
}

const logoBase64Cache = new Map();

async function getLogoBase64(logoUrl) {
  if (!logoUrl) return null;
  if (logoBase64Cache.has(logoUrl)) return logoBase64Cache.get(logoUrl);
  const base64 = await imageUrlToBase64(logoUrl);
  logoBase64Cache.set(logoUrl, base64);
  return base64;
}

export async function buildConseilPvSchoolInfo(settings, schoolDetails) {
  const logoUrl = resolveSchoolLogoUrl(settings, settings?.activeBuilding);
  const schoolLogo = await getLogoBase64(logoUrl);
  return {
    region:
      schoolDetails?.delegeRegional || schoolDetails?.gouvernorat || "",
    schoolYear: formatSchoolarYearName(settings),
    schoolName:
      schoolDetails?.ArabicName || schoolDetails?.name || "",
    schoolCode:
      schoolDetails?.establishmentCode || schoolDetails?.schoolCode || "",
    schoolLogo,
  };
}
